import { render, staticRenderFns } from "./TariffStructure.vue?vue&type=template&id=951c3c44"
import script from "./TariffStructure.vue?vue&type=script&lang=js"
export * from "./TariffStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports